import {
    keyIssueApplyModelUpdate,
    keyIssueCancelModelUpdate
} from "../../../../actions/key-issue-actions"

import buildEditFormActionButtonsWidgetContainer from "../../../common/build-edit-form-action-buttons-widget-container"

export default buildEditFormActionButtonsWidgetContainer(
    keyIssueApplyModelUpdate,
    keyIssueCancelModelUpdate,
    "keyIssues"
)
